module.exports = __webpack_public_path__ + "img/fireplace.6b4572b1.png";